var map = {
	"./5a36954d40bea2.0735336615135266052652.png": 163,
	"./7-2-python-logo-free-download-png.png": 164,
	"./85390-java-language-text-programming-logo-programmer.png": 165,
	"./GNIT_Kolkata_logo.png": 166,
	"./HighRadius-Trifecta-2020.svg": 167,
	"./Problem solving through Programming In C.jpg": 168,
	"./Programming in Java.jpg": 169,
	"./Soft skills.jpg": 170,
	"./The Joy of Computing using Python.jpg": 171,
	"./address_image.svg": 172,
	"./animated_ashutosh.png": 173,
	"./animated_logo.svg": 174,
	"./blogs_image.svg": 175,
	"./cloud_infrastructure.svg": 176,
	"./codeInLogo.png": 177,
	"./contactMail.png": 178,
	"./coursera_logo.png": 179,
	"./data_science.svg": 180,
	"./deeplearning_ai_logo.png": 181,
	"./delhivery_logo.png": 182,
	"./developerActivity.svg": 183,
	"./dp.jpg": 184,
	"./dsc_logo.png": 185,
	"./education.svg": 186,
	"./experience.svg": 187,
	"./feelingProud.svg": 188,
	"./freecopy_logo.png": 189,
	"./fullstack.svg": 190,
	"./gcp_logo.png": 191,
	"./github_logo.png": 192,
	"./googleAssistant.jpg": 193,
	"./googleAssistant.svg": 194,
	"./google_logo.png": 195,
	"./ibm_logo.png": 196,
	"./icims-logo-r.svg": 197,
	"./iiitk_logo.png": 198,
	"./ineuron-logo (1).png": 199,
	"./ineuron-logo.png": 200,
	"./intel_logo.jpg": 201,
	"./javascript-39404.png": 202,
	"./jsFramework.svg": 203,
	"./kisspng-instructor-led-training-learning-course-education-styled-layer-descriptor-5b1b7a2b0911e6.1200257615285274030372.png": 204,
	"./kisspng-react-javascript-angularjs-ionic-atom-5b154be6947457.3471941815281223426081.png": 205,
	"./legato_logo.png": 206,
	"./manOnTable.svg": 207,
	"./microsoft_logo.png": 208,
	"./mozilla_logo.png": 209,
	"./muffito_logo.png": 210,
	"./my-contact-info-photo.jpg": 211,
	"./my-homepage-photo.jpg": 92,
	"./nav_logo.png": 212,
	"./nextuLogo.jpg": 213,
	"./nptel_logo.png": 214,
	"./p2.png": 215,
	"./portfolio.gif": 216,
	"./programmer.svg": 217,
	"./projects_image.svg": 218,
	"./pwa.png": 219,
	"./saayaHealthLogo.png": 220,
	"./stanford_logo.png": 221,
	"./talksCardBack.svg": 222,
	"./talksCardBackAlt.svg": 223,
	"./ui_ux_design.svg": 224
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 53;